import { DropZone, ErrorMessage, Text } from '../../Typhography';
import { Button } from '../Button';
import { strings } from '../../../strings';
import { UploadPicture } from '../../../assets/Modal';

interface UploadImageProps {
  buttonText: string;
  error?: string;
}

const UploadImage = (props: UploadImageProps) => {
  const { buttonText, error } = props;

  return (
    <DropZone>
      <img src={UploadPicture} alt="Upload Image" />
      <Button height={40} width={160}>
        <p>{buttonText}</p>
      </Button>
      <Text color="gray">{strings.dragAndDrop}</Text>

      {error && (
        <ErrorMessage style={{ position: 'relative', left: 0, bottom: 0 }}>{error}</ErrorMessage>
      )}
    </DropZone>
  );
};

export default UploadImage;
